import { pdf } from '@react-pdf/renderer';
import SrPlacementPDF from './srCollegePurePDF';
import { sendEmail } from '../../../Email/EmailSend';

  

export async function CallMailDetails(result) {
 // Generate PDF
 const text = `
 Dear ${result.employeeName},

Thank you for submitting your form at Himanshu Salary Corner. We have successfully processed your request, and your result is now available.

Please find attached a PDF document containing your result according to your form submission details. Kindly review the document, and if you have any questions or require further assistance, feel free to reach out to us.

Company Details:
📍 Himanshu Salary Corner
🏢 159 Guruwar Peth, Satara
📞 +91 9529402894

We appreciate your trust in our services and look forward to assisting you again in the future.

Best regards,
Himanshu Salary Corner
📩 admin@himanshusalarycorner.in
🌐 himanshusalarycorner.in
 `;

  const pdfBlob = await pdf(<SrPlacementPDF result={result} />).toBlob();
  const subject = `Seventh Placement of Serior College Teacher: ${result.employeeName}`;
  const pdfName = `Seventh_placement_${result.employeeName}_${result.placementDate}.pdf`;
  sendEmail(result.email, subject, pdfBlob, text, pdfName);
}
